import { render, staticRenderFns } from "./ConfirmationPrompt.vue?vue&type=template&id=38be2506&scoped=true&"
import script from "./ConfirmationPrompt.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationPrompt.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmationPrompt.vue?vue&type=style&index=0&id=38be2506&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38be2506",
  null
  
)

export default component.exports